import React from 'react';
import ReactDOM from 'react-dom';
import fetch from 'isomorphic-unfetch';
import es6promise from 'es6-promise';
import { merge } from 'lodash';
import Spinner from 'common-ui-components/dist/components/Molecules/Spinner';
import checkStatus from './checkStatus';
import notifyError from './notifyError';
import { GET } from '../constants';
import { buildUrl } from './utils';
import { setLoaderStatus } from '../global/actions';
import { DEFAULT_REDUX_KEY } from '../lib/dynamicStore/constants';

es6promise.polyfill();

/* eslint-disable */

const defaultConfig = {
  method: GET,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

export const loader = flag => {
  let element = document.getElementById('loader');
  if (!element) {
    element = document.createElement('div');
    element.setAttribute('id', 'loader');
    document.body.appendChild(element);
  }
  const props = {
    isLoading: flag,
  };
  ReactDOM.render(<Spinner {...props} />, document.getElementById('loader'));
  const store = window[DEFAULT_REDUX_KEY];
  if (store) {
    store.dispatch(setLoaderStatus(flag));
  }
  return flag;
};
class ServiceUtils {
  sessions;

  constructor(sessions = {}) {
    this.sessions = sessions;
  }

  setSessionID(sessionName, sessionId) {
    this.sessions[sessionName] = sessionId;
  }

  fetch = (pathname, options = {}) => {
    let config = {};
    const {
      fetchProps,
      query,
      pathVars,
      showLoader,
      isNextAPICall,
      storageUrl,
      redirectUrl,
      skipResponseValidation = false,
      skipUnAuthenticationError = false,
      suppressErrorNotification = false,
    } = options;
    if (showLoader) {
      loader(showLoader);
    }
    if (fetchProps.body && !options.hasOwnProperty('skipRequestBodystringify')) {
      fetchProps.body = JSON.stringify(fetchProps.body);
    }
    const defaultConfigObj = options.hasOwnProperty('skipDefaultConfig') ? {} : defaultConfig;
    config = merge({}, defaultConfigObj, fetchProps);

    const url = buildUrl({ pathname, query, pathVars });
    return fetch(url, config)
      .then(res => {
        if (showLoader && !isNextAPICall) {
          loader(false);
        }
        return checkStatus(
          res,
          storageUrl,
          redirectUrl,
          skipResponseValidation,
          skipUnAuthenticationError
        );
      })
      .catch(error => {
        if (showLoader) {
          loader(false);
        }
        if (!suppressErrorNotification) {
          notifyError();
        }
        return Promise.reject(error);
      });
  };
}
/* eslint-enable */

export default new ServiceUtils();
